
import isEqual from 'lodash/isEqual';
import merge from 'lodash/merge';

const lastAttributes = {};

export const mergeWithExistingHotjarAttrs = (newAttributes) => {
    lastAttributes.current = lastAttributes.current || {};
    const mergedAttributes = merge({}, lastAttributes.current, newAttributes);
    return mergedAttributes;
};

export const clearHotjarAttrs = () => {
    lastAttributes.current = {};
};

export const hotjarIdentify = (attributes) => {
    if (window.HOTJAR_ENABLED) {
        if (isEqual(lastAttributes.current, attributes)) {
            return;
        }
        if (typeof window.hj === 'function' && attributes.session_id) {
            window.hj('identify', window.HOTJAR_ID, attributes);
            lastAttributes.current = attributes;
        } else {
            console.warn(`Hotjar Identify Error: ${attributes.session_id}` ? 'Hotjar not initialized'
                : 'capi session id is not available');
        }
    }
};

export const getHotjarAttrsFromState = (state) => {
    let attrs = {};
    if (window.HOTJAR_ENABLED) {
        
        attrs = {
            session_id: state.getIn(['capi', 'sessionID'], null),
            payment_method: state.getIn(['form', 'payment', 'values', 'paymentMethod'], null),
            order_total: 0,
            has_message: false,
            no_of_items: 0,
            scheduled_delivery: false,
            greeting_attached: false
        };
        try {
            const items = state.getIn(['items'], []);
            
            let hasSelfBuy = false;
            let hasGifting = false;
            
            let hasPlastic = false;
            let hasEgc = false;
            
            let hasLink = false;
            let hasEmail = false;

            items.forEach((item) => {
                try {
                    if (item.get('isRemoved', false) === false) {
                        attrs.no_of_items += 1;
                        attrs.order_total += Math.ceil(item.get('amount', 0));
                        attrs.currency = item.get('currencyCode', null);
                        attrs.country = item.get('countryCode', null);

                        if (item.get('isSelfBuy', null) === true) {
                            hasSelfBuy = true;
                        } else if (item.get('isSelfBuy', null) === false) {
                            hasGifting = true;
                        }

                        if (item.get('isPlastic', null) === true) {
                            hasPlastic = true;
                        } else if (item.get('isPlastic', null) === false) {
                            hasEgc = true;
                        }

                        if (item.get('isSharedViaLink', null) === true) {
                            hasLink = true;
                        } else if (item.get('isSharedViaLink', null) === false) {
                            hasEmail = true;
                        }

                        if (item.get('message')) {
                            attrs.has_message = true;
                        }

                        const currentTime = new Date();
                        const deliveryTime = new Date(item.get('deliveryTime'));
                        if (deliveryTime > currentTime) {
                            attrs.scheduled_delivery = true;
                        }

                        if (item.get('greetings', null)) {
                            attrs.greeting_attached = true;
                        }
                    }
                } catch (itemError) {
                    
                }
            });
            
            if (hasSelfBuy && hasGifting) {
                attrs.purchase_type = 'mixed';
            } else if (hasSelfBuy) {
                attrs.purchase_type = 'self';
            } else {
                attrs.purchase_type = 'gifting';
            }
            
            if (hasPlastic && hasEgc) {
                attrs.card_type = 'mixed';
            } else if (hasPlastic) {
                attrs.card_type = 'plastic';
            } else {
                attrs.card_type = 'digital';
            }
            
            if (hasLink && hasEmail) {
                attrs.delivery_type = 'mixed';
            } else if (hasLink) {
                attrs.delivery_type = 'link';
            } else {
                attrs.delivery_type = 'email';
            }
            
            attrs.order_number = state.getIn(['orderData', 'orderNumber'], null);
            attrs.total_with_offer = Math.ceil(state.getIn(['payment', 'grandTotal'], 0));
            attrs.promo_nudge_seen = state.getIn(['promo', 'nudgeSeen'], false);
        } catch (error) {
            
        }
    }
    return attrs;
};
